"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Button_1 = __importDefault(require("../Button"));
function CarBackButton(_a) {
    var history = _a.history, path = _a.path;
    function goBack() {
        history.push(path);
    }
    return (react_1.default.createElement(Button_1.default, { onClick: goBack, transparent: true }, "\u043D\u0430\u0437\u0430\u0434 \u043A \u0441\u043F\u0438\u0441\u043A\u0443"));
}
exports.default = CarBackButton;
CarBackButton.displayName = 'CarBackButton';
CarBackButton.propTypes = {
    history: prop_types_1.default.shape({
        push: prop_types_1.default.func,
    }).isRequired,
    path: prop_types_1.default.string.isRequired,
};
